<template>
    <div ref="mapRef" class="map"></div>
</template>

<script>
import L from 'leaflet';

export default {
    props: {
        device: {
            type: Object,
            default: null
        },
        nfcTag: {
            type: Object,
            default: null
        },
        nfcTags: {
            type: Array,
            default: () => []
        },
        checkpoints: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            map: null,
            deviceMarker: null,
            nfcTagMarker: null,
            tagsMarkers: [],
            checkpointsMarkers: [],
        }
    },
    mounted() {
        this.map = L.map(this.$refs.mapRef).setView([50.0795, 14.4302], 16);

        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 20
        }).addTo(this.map);

        if (this.device) {
            this.renderDevice(this.device);
        }

        if (this.nfcTag) {
            this.renderNfcTag(this.nfcTag);
        }

        if (this.nfcTags) {
            this.renderNfcTags(this.nfcTags);
        }

        if (this.checkpoints) {
            this.renderCheckpoints(this.checkpoints);
        }

    },
    methods: {
        renderDevice(device) {
            const latLng = [device.latitude, device.longitude];

            if (!this.deviceMarker) {
                this.deviceMarker = L.circleMarker(latLng, {
                    radius: 8,
                    color: "blue",
                    fillColor: "blue",
                    fillOpacity: 0.8
                }).addTo(this.map);

                if (device.name) {
                    this.deviceMarker.bindPopup(`<strong>${device.name}</strong>`);
                }
            } else {
                this.deviceMarker.setLatLng(latLng)
            }

            this.fitAllBounds();
        },
        renderNfcTag(nfcTag) {
            const latLng = [nfcTag.latitude, nfcTag.longitude];

            if (!this.nfcTagMarker) {
                this.nfcTagMarker = L.circleMarker(latLng, {
                    radius: 8,
                    color: "#dc3545",
                    fillColor: "#dc3545",
                    fillOpacity: 0.8
                }).addTo(this.map);

                if (nfcTag.name) {
                    this.nfcTagMarker.bindPopup(`<strong>${nfcTag.name}</strong>`);
                }
            } else {
                this.nfcTagMarker.setLatLng(latLng);
            }

            this.fitAllBounds();
        },
        renderNfcTags(nfcTags) {
            this.tagsMarkers.forEach(marker => this.map.removeLayer(marker));
            this.tagsMarkers = [];

            nfcTags.forEach(tag => {
                const lat = tag.latitude;
                const lng = tag.longitude;

                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

                const marker = L.circleMarker([lat, lng], {
                    radius: 6,
                    color: "#dc3545",
                    fillColor: "#dc3545",
                    fillOpacity: 0.8
                }).addTo(this.map)

                marker.bindPopup(`<strong>${tag.name}</strong>`);
                this.tagsMarkers.push(marker);
            });

            this.fitAllBounds();
        },
        renderCheckpoints(checkpoints) {
            this.checkpointsMarkers.forEach(marker => this.map.removeLayer(marker));
            this.checkpointsMarkers = [];

            checkpoints.forEach(cp => {
                const lat = cp.latitude;
                const lng = cp.longitude;

                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

                const marker = L.circleMarker([lat, lng], {
                    radius: 6,
                    color: "#28a745",
                    fillColor: "#28a745",
                    fillOpacity: 0.8
                }).addTo(this.map)

                this.checkpointsMarkers.push(marker);

            });

            this.fitAllBounds();
        },
        fitAllBounds() {
            const latLngs = [];

            if (this.deviceMarker) {
                latLngs.push(this.deviceMarker.getLatLng());
            }
            if (this.nfcTagMarker) {
                latLngs.push(this.nfcTagMarker.getLatLng());
            }

            this.tagsMarkers.forEach(t => latLngs.push(t.getLatLng()));

            this.checkpointsMarkers.forEach(cp => latLngs.push(cp.getLatLng()));

             if (latLngs.length >= 1) {
                const bounds = L.latLngBounds(latLngs);
                this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 19 });
            }
        }
    },
    watch: {
        device: {
            handler(newDevice) {
                if (newDevice?.latitude && newDevice?.longitude) {
                    this.renderDevice(newDevice);
                }
            }
        },
        nfcTags: {
            handler(newTags) {
                if (Array.isArray(newTags)) {
                    this.renderNfcTags(newTags);
                }
            },
            deep: true,
            immediate: true
        },
        checkpoints: {
            handler(newCheckpoints) {
                if (Array.isArray(newCheckpoints)) {
                    this.renderCheckpoints(newCheckpoints);
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style>
.map {
    width: 100%;
    height: 500px;
}
</style>